<template>
  <div class="administracion-prospectos">
    <div class="container">
      <div class="col-12 contenedor-prospectos w-75">
        <TarjetaProspecto v-for="prospecto in prospectos" v-bind:key="prospecto.prospectoId"
          :nombreProspecto="prospecto.nombres" :apellidoPaterno="prospecto.apellidoPaterno"
          :apellidoMaterno="prospecto.apellidoMaterno" :prospectoId="prospecto.prospectoId"
          :montoDeseado="prospecto.montoDeseado" :aliasEtapaStr="NombreEtapaTipoPersona(prospecto.aliasEtapaStr, prospecto.tipoPersona).charAt(0).toUpperCase() +
            NombreEtapaTipoPersona(prospecto.aliasEtapaStr, prospecto.tipoPersona).slice(1).toLowerCase()
            " :fechaStr="prospecto.fechaStr" :toolTip="InsertarTooltip(prospecto.aliasEtapaStr)"
          :etapa="prospecto.aliasEtapaStr" :tipoPersona="prospecto.tipoPersona" :etapaId="prospecto.etapaId"
          :sucursal="prospecto.sucursal" :embajador="prospecto.embajador" @ConsultarEstatus="
            ConsultarEstatusProspecto(prospecto.prospectoId)
            "></TarjetaProspecto>
      </div>
    </div>
    <v-dialog v-model="mostrarDialogSinIncode" width="500">
      <v-card>
        <v-card-text class="pt-5 fw-bold">
          {{ esExtranjero ? 'The holder of the application invites you to perform your identity authentication, do you want to start?' : 
          'El titular de la solicitud te invita a realizar tu autenticación de identidad, ¿deseas comenzar? '}}
         </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="mostrarDialogSinIncode = false">
           {{ esExtranjero ? 'Cancel' : 'Cancelar'}} 
          </v-btn>
          <v-btn color="primary" @click="goTo()">
            {{ esExtranjero ? 'Accept' : 'Aceptar'}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="js">
// Componentes
import TarjetaProspecto from "../../Prospecto/components/TarjetaProspecto.vue";
import axios from "axios";
import { getSession } from "@/Aplicaciones/Masters/apiConnection/api_client";

//Rutas API
var rutaControlador = "/api/Master/Prospecto/ListarSolicitudesProspecto";
const rutaEnviarCorreoPreautorizador = "/api/Master/IntegracionExpediente/EnviarCorreoPagoPreautorizador";
const rutaEnviarCorreoAdministrador = "/api/Master/IntegracionExpediente/EnviarCorreoPagoAdmistrador";
const rutaObtenerEtapaDeTitular = "/api/Master/FiguraAdicional/ObtenerEtapaDeTitular";



export default {
  name: "SeguimientoProspecto",
  components: {
    TarjetaProspecto
  },
  data() {
    return {
      TipoPersona: null,
      ProspectoId: null,
      prospectos: [],
      mostrarDialogSinIncode: false,
      isMobile: /Mobi/i.test(navigator.userAgent),
    };
  },
   mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.TipoPersona = this.$store.getters.tipoPersona;
    document.getElementsByClassName('principal-menu-navegacion')[0].style.display = 'block';
    this.cargarProspectos();
    window.sessionStorage.removeItem('prospectoEditarId');
    window.sessionStorage.removeItem('prospectoId');
    if (this.$store.getters.comprobantePagoEnviado && this.$store.getters.comprobantePagoEnviado != 'undefined') {
      this.EnviarCorreoComprobantePreautorizador();
      this.EnviarCorreoComprobanteAdministrador();
    }
    this.$store.commit("comprobantePagoEnviado", false);


     this.ValidarFirmaIncode()
  },
  methods: {
    goTo() {
      this.$store.commit('setGoToSinOnboarding', {to:'SeguimientoProspecto'})
    if (this.isMobile) {
        this.$router.push({ name: "WelcomeOnBoarding" });
      } else {
        this.$router.push({ name: "InformacionAutenticacionIdentidad" });
      }
    },
    async ValidarFirmaIncode() {
      if(this.$store.state.tipoUsuario == 3 && (this.$store.state.tipoPersona == 4 || this.$store.state.tipoPersona == 5) ){
        const { data } = await axios.get(rutaObtenerEtapaDeTitular+'?prospectoId='+ this.ProspectoId)
        const session = await getSession(this.ProspectoId);
        //EtapaId = 9 : Contratado (Firmas de contratos)
        if (session == null && data.data === 9) this.mostrarDialogSinIncode = true;   
        if((session != null || session != undefined) && data.data === 9 ){
          if(session.finishStatus === 'INCOMPLETE') this.mostrarDialogSinIncode = true;  
        }
      }
    },
    EnviarCorreoComprobantePreautorizador() {
      axios
        .post(rutaEnviarCorreoPreautorizador + "?prospectoId=" + this.ProspectoId)
        .then(() => { }).catch(e => console.log(e));
    },
    EnviarCorreoComprobanteAdministrador() {
      axios
        .post(rutaEnviarCorreoAdministrador + "?prospectoId=" + this.ProspectoId)
        //.then(() => {}).catch(e =>  this.ManejarExcepcion(e));
        .then(() => { }).catch(e => console.log(e)); //Temporal durante revisión de error en el envío de correo
    },
    NombreEtapaTipoPersona(aliasEtapa, tipoPersona) {
      switch (aliasEtapa) {
        case "PRIMER CONTACTO":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "FIRST CONTACT" : aliasEtapa;
        case "ASESORÍA":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "ADVICE" : aliasEtapa;
        case "INTEGRACIÓN DE EXPEDIENTE":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "FILE INTEGRATION" : aliasEtapa;
        case "PRE AUTORIZACIÓN":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "PRE-AUTHORIZATION" : aliasEtapa;
        case "GENERACIÓN INFORMACIÓN DE PAGO":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "GENERATION OF PAYMENT INFORMATION" : aliasEtapa;
        case "PAGO DE CUOTA DE INSCRIPCIÓN":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "PAYMENT OF REGISTRATION FEE" : aliasEtapa;
        case "VALIDAR PAGO":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "VALIDATE PAYMENT" : aliasEtapa;
        case "CONTRATADO":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "CONTRACTED" : aliasEtapa;
        case "PAUSADO":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "PAUSED" : aliasEtapa;
        case "COMPLETADO":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "COMPLETED" : aliasEtapa;
        case "HOJA PRUEBA":
          return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "TEST SHEET" : aliasEtapa;
      }
    },
    InsertarTooltip(etapa) {
      switch (etapa) {
        case 'PRIMER CONTACTO':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "First approach with the prospect where we introduce ourselves and in the same sense a brief explanation of the financing is offered, inviting the prospect to make an appointment and inquire about the topic." : "Primer acercamiento con el prospecto donde nos presentamos y en ese mismo sentido se ofrece una breve explicación del financiamiento, invitando al prospecto a concertar una cita e indagar sobre el tema";
        case 'ASESORÍA':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Our expert advisors guide you to apply for the best financing option, according to your profile." : "Nuestros asesores expertos te guían para solicitar la mejor opción de financiamiento, acorde a tu perfil. ";
        case 'INTEGRACIÓN DE EXPEDIENTE':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "We keep the documents as a source of information, for the organization and development of each process." : "Resguardamos los documentos como fuente de información, para la organización y desarrollo de cada proceso. ";
        case 'PRE AUTORIZACIÓN':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "We verify the fulfillment of certain requirements, in order to make use of the funding." : "Verificamos el cumplimiento de ciertos requisitos, para hacer uso del financiamiento.";
        case 'GENERACIÓN INFORMACIÓN DE PAGO':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "We notify the customer of the data, in order to make the payment of the registration fee." : "Notificamos al cliente los datos, para realizar el pago de la cuota de inscripción.";
        case 'CARGAR COMPROBANTE DE PAGO':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "The customer will load the payment voucher." : "El cliente realizara la carga del comprobante de pago.";
        case 'VALIDAR PAGO':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Confirmation of the firm payment, by the Treasury Area." : "Confirmación del pago en firme, por parte del Área de Tesorería.";
        case 'CONTRATADO':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Finally, the customer will receive the contract for review and signature." : "Por último, el cliente recibirá el contrato para su revisión y firma.";
        case 'PAUSADO':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Prospect paused." : "Prospecto pausado.";
        case 'COMPLETADO':
          return (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Process completed." : "Proceso completado.";
        default:
          break;
      }

      //aparecer modal para cotitulares extranjero y nacional y mandarlo a incode 
      //meter reglas enp preonboarding para regresar a donde corresponde 
    },
    validarCargarProspectos: function (e) {
      e.preventDefault();
      this.cargarProspectos();
    },
    cargarProspectos() {
      axios
        .get(rutaControlador, { headers: { Authorization: window.sessionStorage.getItem("Token") } })
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.prospectos = resp.data.data;
            // axios.defaults.headers.common["Authorization"] =
            //   "Bearer " + this.token;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    esCadenaNulaOTodosEspaciosEnBlanco: function (cadena) {
      return cadena === undefined || cadena === null
        || typeof cadena !== 'string'
        || cadena.match(/^ *$/) !== null;
    }
  },
  computed :{
    esExtranjero(){
      let esExtranjero = [2,5,7] 
      return esExtranjero.includes(this.$store.state.tipoPersona)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.administracion-prospectos {
  background: url("https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/img_admon.png") no-repeat center center fixed;
  background-size: cover;
  width: 100vw;
  flex-grow: 1;
}

.contenedor-prospectos {
  display: inline-table;
  width: 50vw !important;
}

/**ESTILOS MOBILE */
@media (max-width: 512px) {
  .contenedor-prospectos {
    display: inline-table;
    width: 80vw !important;
  }
}
</style>
